import { useState } from 'react';
import { useParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import useLzFApiCall from '@lz/services/Api';
import { useLzOnMount } from '@lz/services/Hooks';
import { lzFIsObject } from '@lz/services/Type';
import LzMRole from '@lz/models/commons/Role';
import { LzTRights } from '@lz-models/commons/Rights';
import LzXCanvas from '@lz-components/commons/Canvas';
import LzXButtonsBar from '@lz-components/widgets/ButtonsBar';
import LzXRightsMatrix from '@lz-components/commons/RightsMatrix';

const LzXRolesRights = () => {
  const [model, setModel] = useState<LzMRole | null>(null);
  const [schema, setSchema] = useState(null);
  const [rights, setRights] = useState<LzTRights>(null);

  const routeParams = useParams();
  const lzApiCall = useLzFApiCall();

  const getRightsMutatationFree = (rights: LzTRights) => lzFIsObject(rights) ? Object.assign({}, rights) : rights;

  const roleId = +(routeParams.id || 0);

  const loadRecord = async () => {
    const data = await lzApiCall('role-rights/' + roleId);

    if (data && data.role && data.schema) {
      setModel(new LzMRole(data.role));
      setSchema(data.schema);
      setRights(getRightsMutatationFree(data.role.rights));
    }
  };

  // Call only for the first time when component is initially loaded
  useLzOnMount(() => {
    loadRecord();
  });

  const onReset = () => setRights(getRightsMutatationFree(model?.rights));

  const onSave = async () => {
    const data = await lzApiCall('role-rights/' + roleId, { rights: rights }, 'post');
    if (data) {
      const updated = new LzMRole(Object.assign({}, model, { rights: rights }));
      setModel(updated);
    }
  };

  if (!model || !schema || !rights) {
    return <CircularProgress />;
  }

  return (
    <LzXCanvas>

      <LzXRightsMatrix
        schema={schema}
        rights={rights}
        onChange={(changed) => setRights(changed)}
      />

      <LzXButtonsBar
        buttons={[
          { title: 'Save Changes', onClick: onSave, variant: 'contained' },
          { title: 'Reload', onClick: loadRecord },
          { title: 'Reset', onClick: onReset },
          { title: 'Go Back', route: '/system/roles' },
        ]}
      />

    </LzXCanvas>
  );
};

export default LzXRolesRights;
